import { ref } from '@/composition/vue/compositionApi'

const onBeforeTabLeave = ref<undefined | (() => boolean)>()

export const useTabsHooks = () => {
  const setOnBeforeTabLeave = (fn?: () => boolean) => {
    onBeforeTabLeave.value = fn
  }

  return {
    onBeforeTabLeave,
    setOnBeforeTabLeave,
  }
}
